/**
 * App shell.
 *
 * Wraps everything in the login gate, then renders the sidebar + mobile
 * top-bar layout. The actual route table lives in `./routes.tsx`.
 */

import { useState } from "react";
import { Router as WouterRouter } from "wouter";
import Sidebar from "../components/Sidebar";
import MobileTopBar from "../components/MobileTopBar";
import { LoginGate } from "../components/LoginGate";
import { ErrorBoundary } from "../components/ErrorBoundary";
import { AppRoutes } from "./routes";

function App() {
  const [mobileNav, setMobileNav] = useState(false);

  return (
    <LoginGate>
      <WouterRouter base={import.meta.env.BASE_URL.replace(/\/$/, "")}>
        <div className="app-shell">
          <Sidebar
            mobileOpen={mobileNav}
            onMobileClose={() => setMobileNav(false)}
          />
          {mobileNav && (
            <div
              className="sidebar-backdrop"
              onClick={() => setMobileNav(false)}
              aria-hidden="true"
            />
          )}
          <main className="main-content">
            <MobileTopBar onOpenNav={() => setMobileNav(true)} />
            <div className="page-content">
              {/*
               * ErrorBoundary sits *inside* the app shell so if a route
               * crashes, the sidebar + sign-out still work. A crash here
               * used to unmount the whole tree and white-screen the user
               * (most often staff, when a page tried to format a finance
               * field that was stripped from the response).
               */}
              <ErrorBoundary>
                <AppRoutes />
              </ErrorBoundary>
            </div>
          </main>
        </div>
      </WouterRouter>
    </LoginGate>
  );
}

export default App;
